import React, { type PropsWithChildren } from "react";

import { Table } from "@devexpress/dx-react-grid-bootstrap4";

export const TableRow = (props: PropsWithChildren<Table.DataRowProps>) => {
  const hasChildren = props.row.children.length > 0;
  return <Table.Row {...props} className={hasChildren ? "even" : "odd"} />;
};
